// Status must come from the API for the saved order, never from a return URL.
export const getBookingConfirmation = (trackingData, status) => {
  if (!trackingData?.bookingId || !status) return null;
  if (status.orderId != null && trackingData.orderId != null &&
      String(status.orderId) !== String(trackingData.orderId)) return null;
  const paymentStatus = status.paymentStatus;
  if (paymentStatus === 'Cancelled' || status.status === 'Cancelled') {
    return { confirmed: false, terminal: true };
  }
  if (trackingData.kind === 'coupon') {
    return paymentStatus === 'Paid' && status.succeeded === true
      ? { confirmed: true, onlinePaid: true, value: status.onlinePaymentValue }
      : null;
  }
  if (status.confirmed !== true) return null;
  if (paymentStatus === 'Paid' && status.isOnlinePayment === true) {
    return { confirmed: true, onlinePaid: true, value: status.onlinePaymentValue };
  }
  if (status.isOnlinePayment === false &&
      ['Paid', 'PSDF', 'Draudimas', 'Coupons', 'NotBillable', 'OnSite', 'Juridical'].includes(paymentStatus)) {
    return { confirmed: true, onlinePaid: false };
  }
  return null;
};

export const getBookingStatusPath = (data) => {
  const id = data?.registrationId || data?.orderId;
  if (!id) return null;
  const query = encodeURIComponent(id);
  if (data.kind === 'registration') return `/RegistrationManagement/RegistrationStatus?registrationId=${query}`;
  if (data.kind === 'complex') return `/ComplexServiceRegistrationManagment/ComplexRegistartionStatus?complexOrderId=${query}`;
  if (data.kind === 'coupon') return `/CouponManagement/CouponStatus?couponOrderId=${query}`;
  return null;
};
